import type { ToolbarConfig } from './types';

export const DEFAULT_TOOLBAR_CONFIG: ToolbarConfig = {
  bold: true,
  italic: true,
  underline: true,
  link: true,
  bulletList: true,
  orderedList: true,
};
